import { Autoplay, Pagination, Swiper } from 'swiper';

Swiper.use([Autoplay, Pagination]);

export default direction => {
    return {
        activeSlide: 0,
        open: false,
        swiper: null,
        ttl: 0,
        close() {
            this.open = false;
            this.setPopupExpiry(this.ttl);
        },
        init(ttl) {
            this.ttl = ttl || 36E5; // 1hr
            this.$watch('open', value => {
                let classListAction;
                if (true === value) {
                    classListAction = 'add';
                    this.initSwiper();
                } else {
                    classListAction = 'remove';
                    this.swiper.destroy();
                }
                document.body.classList[classListAction]('overflow-hidden');
            });
            if (this.isPopupExpired()) {
                document.body.classList.add('overflow-hidden');
                setTimeout(() => { this.open = true }, 1000);
            }
        },
        initSwiper() {
            this.swiper = new Swiper(this.$refs.swiper, this.options());
            this.swiper.on('slideChange', swiper => {
                this.activeSlide = swiper.activeIndex;
            });
            setTimeout(() => this.swiper.update(), 500);
        },
        isPopupExpired() {
            const expiry = localStorage.getItem('popup');
            if (!expiry || '/' === window.location.pathname) {
                return true; // always show popup on homepage!
            }
            const now = new Date();
            if (now.getTime() > expiry) {
                localStorage.removeItem('popup');
                return true;
            }
            return false;
        },
        options() {
            return {
                autoplay: {
                    delay: 4000,
                },
                direction: 'horizontal',
                grabCursor: true,
                initialSlide: this.activeSlide,
                loop: true,
                pagination: {
                    clickable: true,
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                spaceBetween: 0,
                updateOnWindowResize: true,
                watchOverflow: true,
            };
        },
        setPopupExpiry(ttl) {
            const now = new Date();
            const expiry = now.getTime() + ttl;
            localStorage.setItem('popup', expiry);
        },
        slideTo(index) {
            this.swiper.slideTo(this.activeSlide = index);
        },
    };
};
